import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import { useFormik } from "formik";
import * as Yup from "yup";
import { priceComma } from "../../utils/priceComma";
import RequestTalkModal from "../../components/common/mobile/RequestTalkModal";
import { Helmet } from "react-helmet";
import { DealerDataContext } from "../../context/DealerDataContext";
import { useRouteInfo } from "../../hooks/useRouteInfo";

const PayLaterMobilePage = () => {
  const [ourVehicles, setOurVehicles] = useState();
  const [otherVehicles, setOtherVehicles] = useState();
  const [show, setShow] = useState();

  const { dealerData } = useContext(DealerDataContext);
  const { metaData } = useRouteInfo();

  const lazing = [
    { name: "لیزینگ دولتی", precent: 16 },
    { name: "لیزینگ خصوصی", precent: 10 },
    { name: "لیزینگ نمایشگاه", precent: 5 },
  ];
  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      lazing: Yup.string().required("الزامی است"),
      price: Yup.string().required("الزامی است"),
      firstPay: Yup.string().required("الزامی است"),
      time: Yup.string().required("الزامی است"),
    });
  };

  const formik = useFormik({
    initialValues: {
      lazing: "",
      price: "",
      firstPay: "",
      time: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      if (values.firstPay < (values.price / 100) * 70) {
        return formik.setFieldError(
          "firstPay",
          "پیش پرداخت باید بیشتر از 70 درصد قیمت باشد"
        );
      }
      const percent = lazing.find((e) => e.name == values.lazing).precent;

      const Allprice = values.price + (values.price / 100) * 16;
      const priceByTime = (Allprice - values.firstPay) / values.time;
      setResult({
        price: values.price,
        time: values.time,
        Allprice,
        lazing: values.lazing + " با سود " + percent + "درصد",
        firstPay: values.firstPay,
        priceByTime,
      });

      console.log(values.price / 1000000000);

      const min_price = values.price / 1000000000 - 1;
      const max_orice = values.price / 1000000000 + 1;

      await httpReauest(
        "GET",
        "/vehicle?min_price=" + min_price + "&max_price=" + max_orice,
        {},
        {}
      ).then(({ data }) => {
        setOurVehicles(data?.data.slice(0, 4));
      });

      await httpReauest("GET", "/vehicle", {}, {}).then(({ data }) => {
        setOtherVehicles(data?.data?.slice(0, 4));
      });
    },
  });

  const [result, setResult] = useState({
    lazing: "",
    price: "",
    firstPay: "",
    time: "",
    Allprice: "",
    priceByTime: "",
  });
  return (
    <div className="text-[14px] sm:text-[16px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      {show && <RequestTalkModal setShow={setShow} />}
      <Link to={"/"} className="flex gap-2 items-center text-[14px]">
        <img src="/Arrow - Left 2.png" alt="" className="w-[24px]" />
        بازگشت به صفحه خانه
      </Link>
      <div className="py-4">
        <h1 className="title-mobile text-center">{metaData?.h1}</h1>
        <form onSubmit={formik.handleSubmit}>
          <select
            className={` w-full form-brand-mobile mt-4`}
            name="lazing"
            id="lazing"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lazing}
          >
            <option value={""}>نوع لیزینگ</option>
            {lazing.map((e) => (
              <option value={e.name}>{e.name}</option>
            ))}
          </select>
          {formik.errors.lazing && formik.touched.lazing && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.lazing}
            </small>
          )}
          <input
            className={`w-full form-brand-mobile mt-4`}
            placeholder="مبلغ خودرو"
            name="price"
            id="price"
            type="number"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.price}
          />
          {formik.errors.price && formik.touched.price && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.price}
            </small>
          )}
          <input
            className={`w-full form-brand-mobile mt-4`}
            placeholder="پیش پرداخت"
            name="firstPay"
            id="firstPay"
            type="number"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.firstPay}
          />
          {formik.errors.firstPay && formik.touched.firstPay && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.firstPay}
            </small>
          )}
          <input
            className={`w-full form-brand-mobile mt-4`}
            placeholder="تعداد اقساط"
            name="time"
            type="number"
            id="time"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.time}
          />
          {formik.errors.time && formik.touched.time && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.time}
            </small>
          )}
          <div className="mt-4">
            <button type="submit" className="btn-brand w-full ">
              محاسبه
            </button>
          </div>
        </form>
        <div className="py-7">
          {result.Allprice && (
            <span className="flex flex-col gap-4 text-[14px]">
              <span className="grid grid-cols-2 ">
                <p className=" font-[700]">نوع لیزینگ</p>
                <p className="">{result.lazing}</p>
              </span>
              <span className="grid grid-cols-2 ">
                <p className=" font-[700]">مبلغ خودرو</p>
                <p className="">{priceComma(result.price, 2)}</p>
              </span>
              <span className="grid grid-cols-2 ">
                <p className=" font-[700]">پیش پرداخت</p>
                <p className="">{priceComma(result.firstPay, 2)}</p>
              </span>
              <span className="grid grid-cols-2 ">
                <p className=" font-[700]">اقساط</p>
                <p>{result.time} ماهه</p>
              </span>
              <span className="grid grid-cols-2 ">
                <p className=" font-[700]">مبلغ هر قسط</p>
                <p className="">{priceComma(result.priceByTime, 2)}</p>
              </span>
              <span className="grid grid-cols-2 ">
                <p className=" font-[700]">جمع کل اقساط</p>
                <p className="">{priceComma(result.Allprice, 2)}</p>
              </span>
            </span>
          )}
        </div>
        <Link
          to={`tel:${dealerData?.phone}`}
          className="border-brand-2 p-2 w-full block text-center my-2"
        >
          درباره شرایط اقساطی - {dealerData?.phone}
        </Link>
        <button
          onClick={() => setShow(true)}
          className="border-brand-2 p-3 w-full block text-center mt-3 mb-7"
        >
          درخواست مشاوره تلفنی
        </button>
      </div>
    </div>
  );
};

export default PayLaterMobilePage;
